<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/LYIi49/images/9781540262554.jpg?1732629343445" alt="This image is the cover for the book Oregon Caves National Monument and Preserve, Images of America"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Oregon Caves National Monument and Preserve, Images of America
      </h1>
      <p class="bookDescription body article font2">
        <p>A stunning history of the development and preservation of the marble halls deep within the Siskiyou Mountains. In 2014 the designation of the Monument changed to the Oregon Caves National Monument and Preserve and the footprint was expanded to 4,554 total acres. The Friends of the Oregon Caves and Chateau have selected the best photographs to visually represent the colorful history of this iconic national treasure.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ms. Lucinda Suezanne Rosefine Harwood, Ms. Susan Ogle Densmore
      </h2>
      
      <p class="authorDescription body article">The Friends of the Oregon Caves and Chateau have selected the best photographs to visually represent the colorful history of this iconic national treasure.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Arcadia Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?93f4feac